import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-icon-button',
  template: `
    <p>
      icon-button works!
    </p>
  `,
  styles: [
  ],
})
export class IconButtonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
